import { observable, action, runInAction, toJS } from 'mobx'
import remotedev from 'mobx-remotedev'
import { StoreExt } from '@utils/reactExt'

export class Notifications extends StoreExt {
    @observable loading = false
    @observable list = []
    @observable pageIndex = null
    @observable totalCount = null
    @observable filters = {}

    @action
    getNotifications = async params => {
        this.loading = true
        this.api.notificationService
            .getList({ ...params, filters: toJS(this.filters) })
            .then((res: any) => {
                runInAction(() => {
                    this.list = res.results
                    this.pageIndex = res.pageIndex
                    this.totalCount = res.totalCount
                    this.loading = false
                })
            })
            .catch(error => {
                throw new Error(error)
            })
    }

    @action
    updateFilters = params => {
        runInAction(() => {
            this.filters = params
        })
    }
}

export default remotedev(new Notifications())
